import React, { useEffect, useState } from 'react';
import CommunityImg from '../../Common/CommunityImg/CommunityImg';
import { default as img } from '../../../images/industry_experts_join_mural.svg';
import { default as boy } from '../../../images/industry_Experts_edu_boy.svg';
import { default as girl } from '../../../images/industry_Experts_edu_girl.svg';
import useIndustryExpertsEduTainment from '../../hooks/useIndustryExpertsEduTainment';
import './IndustryExpertsFollow.scss';
import IndustryExpertsBlogModal from '../IndustryExpertsBlogModal/IndustryExpertsBlogModal';

export default function IndustryExpertsFollow() {

  const EduTainment = useIndustryExpertsEduTainment();
  const [open, setOpen] = useState(false);
  const [selectedBlog, setSelectedBlog] = useState(null);
  const {allContentfulCommunityIndustryExpertsEduTainment : {edges : EduTainmentList}} = EduTainment;

  const openBlog = (blogItem) => {
    setOpen(true);
    setSelectedBlog(blogItem)
  }

  return (
    <>
      <div className="industry-experts-follow-container">
        <div className="industry-experts-follow-heading">
          <CommunityImg className="industry-experts-img" src={boy} />
          <div className="content">
            <div className="industry-experts-follow-title">
              For Your Edu-tainment
            </div>
            <div className="industry-experts-follow-hash-tag">
              Don't miss out on all the exciting things noissue and our Industry Experts are up to!
            </div>
          </div>
          <CommunityImg className="industry-experts-img"  src={girl} />
        </div>
        <div className={`industry-experts-edu-tainment-list ${EduTainmentList.length < 5 && 'no-scroll' }`}>
          {
            EduTainmentList.map((eduTainment, idx) => {
              return <div key={`edutainment-${idx}`} className = "edutainment-item" onClick={()=>openBlog(eduTainment)}>
                <CommunityImg src={eduTainment.node.featureImage.file.url} alt={`${eduTainment.node.title}`} />
                <div className="description">
                  {eduTainment.node.title}
                </div>
              </div>
            })
          }
        </div>
        <div className="industry-experts-follow-bottom-img">
          <CommunityImg src={img} alt="expert follow pic" />
        </div>
      </div>
      {
        open && <IndustryExpertsBlogModal 
          isOpen ={open}
          onClose = {()=>setOpen(false)}
          blog = {selectedBlog}
          blogList = {EduTainmentList} />
      }
    </>
  )
}
